import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { Chart, ChartComponentLike } from 'chart.js';
import { StudentDomainScore } from '../data/student-domain-scores';

@Component({
  selector: 'app-student-domain-scores',
  templateUrl: './student-domain-scores.component.html',
  styleUrls: ['./student-domain-scores.component.scss']
})

export class StudentDomainScoresComponent extends BaseComponent implements OnInit {
  @Input() scores: StudentDomainScore[];

  @ViewChild('speakingChartElement') speakingChartElement!: ElementRef<HTMLDivElement>;
  @ViewChild('listeningChartElement') listeningChartElement!: ElementRef<HTMLDivElement>;
  @ViewChild('readingChartElement') readingChartElement!: ElementRef<HTMLDivElement>;
  @ViewChild('writingChartElement') writingChartElement!: ElementRef<HTMLDivElement>;

  speakingText: string;
  listeningText: string;
  readingText: string;
  writingText: string;

  percentFormatter = new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });

  ngOnInit(): void {

  }

  ngAfterViewChecked(): void {
    this.updateCharts(this.scores);
  }

  updateCharts(scores: StudentDomainScore[]) {
    if(!scores || this.speakingText) return; // only run after getting data and only once

    let speaking = scores.find(x=>x.Domain == "Speaking")?.CorrectRate;
    let listening = scores.find(x=>x.Domain == "Listening")?.CorrectRate;
    let reading = scores.find(x=>x.Domain == "Reading")?.CorrectRate;
    let writing = scores.find(x=>x.Domain == "Writing")?.CorrectRate;

    // had trouble passing string ref into function and modifying so this is outside
    this.speakingText = speaking ? this.percentFormatter.format(speaking) : '--%';
    this.listeningText = listening ? this.percentFormatter.format(listening) : '--%';
    this.readingText = reading ? this.percentFormatter.format(reading) : '--%';
    this.writingText = writing ? this.percentFormatter.format(writing) : '--%';

    this.updateDomain(this.speakingChartElement, this.speakingText, speaking);
    this.updateDomain(this.listeningChartElement, this.listeningText, listening);
    this.updateDomain(this.readingChartElement, this.readingText, reading);
    this.updateDomain(this.writingChartElement, this.writingText, writing);
  }

  updateDomain(element: ElementRef<HTMLDivElement>, textRef: string, value: number): void {
    this.updateBackground(element, value);

    // update text color
    let color = ""; 
    if(!value) color = "#03B1F2"; // undefined number, uses $selectedTextColor from variables.scss 
    else if(value >= .63) color = "#89bb17"; 
    else if(value >= .25) color = "#fbb143";
    else color = "#fd3d34";

    element.nativeElement.style.color = color; 
  }

  updateBackground(element: ElementRef<HTMLDivElement>, value: number) {
    value = value || 0;
    if (value == 0) { // had issues with a thin blue line showing even when set to start/stop at 0deg
      element.nativeElement.style.background = 'conic-gradient(#ffffff 0deg 360deg)';
    } else if (value >= .995) { // >=.995 currently displays as 100% due to Intl.NumberFormat settings
      element.nativeElement.style.background = 'conic-gradient(#07a5d0 0deg 360deg)';
    } else {
      let end = value * 360;
      let start = Math.max(end - 3, 0); // apply 2 degrees of gradient to avoid sharp/blocky boundary
      element.nativeElement.style.background = 'conic-gradient(#07a5d0 0deg '+start+'deg, #ffffff '+end+'deg 360deg)';
    }
  }
}
